define(['angular'], function(angular) {


    /**
     * @class StoreTypeService
     */
    function StoreTypeService() {
        var self = this;
        var storeTypes = [];

        self.initStoreTypes = function _initStoreTypes(orderForm) {
            storeTypes = orderForm.storeTypes;
        };

        self.getStoreTypeByCode = function getStoreTypeByCode(storeTypeCode) {
            return storeTypes.find(function(storeType) {
                return storeType.code === storeTypeCode;
            });
        };

        return self;
    }

    StoreTypeService.$inject = [];

    angular.module('app.bdc.common.storeTypeService', []).factory('storeTypeService', StoreTypeService);
});
